export function buildQueryString(
  queryParams?: Record<string, unknown> | null,
  defaults?: Record<string, unknown> | null
): string {
  const merged: Record<string, unknown> = {
    ...(defaults || {}),
    ...(queryParams || {})
  };

  const parts: string[] = [];
  Object.keys(merged).forEach((key) => {
    const value = (merged as any)[key];
    if (value !== undefined && value !== null && value !== '') {
      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
    }
  });

  return parts.length ? `?${parts.join('&')}` : '';
}


